module.exports = __webpack_public_path__ + "img/logo.2fe2144a.jpg";